<template>
  <div class="cn-category-cards">
    <div class="cn-category-cards__content">
      <div
        v-for="(categoryCard, i) in category.children"
        :key="i"
        :class="classOfCard(i)"
      >
        <UiLink :to="`/product-category/${category.slug}/${categoryCard.slug}`">
          <CategoryCard
            :image="
              categoryCard.images &&
              categoryCard.images[0] &&
              categoryCard.images[0].url
            "
            :name="categoryCard.name"
            :models-count="categoryCard.products_count"
            :color="categoryCard.color"
            :small="isSmall(i)"
          />
        </UiLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CategoryCard from '@/components/CategoryCard';
import UiLink from '@/components/ui/UiLink';
// TODO: fix type
interface Props {
  category: any;
}
const props = defineProps<Props>();

const classOfCard = (index: number) => {
  let res = '';
  const categoryChildrenLength = props.category.children.length;

  if (index === 0) {
    res = 'sm:col-span-4 lg:col-span-2';
  } else if (index === categoryChildrenLength - 1) {
    res =
      categoryChildrenLength === 3
        ? 'sm:col-span-2 lg:col-span-1'
        : 'sm:col-span-4 lg:col-span-2';
  } else {
    res = 'sm:col-span-2 lg:col-span-1';
  }

  return res;
};

const isSmall = (index: number) => {
  const categoryChildrenLength = props.category.children.length;

  if (index === 0) {
    return false;
  }

  if (index === categoryChildrenLength - 1) {
    return categoryChildrenLength === 3;
  }

  return true;
};
</script>

<style lang="scss">
.cn-category-cards {
  &__content {
    gap: var(--size-xl);
    grid-template-columns: repeat(4, minmax(0, 1fr));
    display: grid;
  }
}
</style>
